import * as types from './mutation-types'

export const setAccess = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('set/access', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const setAccessHours = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('set/access/hours', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const setAccessMethods = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('create/door/user/access/method', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const updateAccessMethods = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.patch(`update/door/user/${data.id}/access/method/${data.key}`, data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const deleteAccessMethods = ({ commit }, data) => {
    return new Promise((resolve, reject) => {

        window.axios.delete(`delete/door/user/${data.id}/access-methods/${data.key}`).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const removeAccess = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('remove/access', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const getDayCollection = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/days/collection', data).then((response) => {
            commit(types.LOAD_DAYS, response.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const shareConfig = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('transfer/user/access/method', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
